export enum QuoteStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
}

export interface Quote {
  id: string;
  quoteNumber: string;
  createdAt: string;
  customerNameKey: string;
  projectTypeKey: string;
  revisionNumber: number;
  totalValue: number;
  status: QuoteStatus;
  validUntil: string;
  descriptionKey: string;
}

export interface QuotesState {
  list: Quote[];
  selectedQuote: Quote | null;
  loading: boolean;
  detailLoading: boolean;
  error: string | null;
  search: string;
  statusFilter: QuoteStatus | "ALL";
}